function Team() {

    console.log("team");

    var self = this;

    $("#locations")

        .select2({

            minimumResultsForSearch: -1

        })
        .on('change', function () {

            console.log("value");

            console.log(this.value);

            if (this.value === "All"){

                console.log("all");

                TweenMax.set('.team-office', {display:'block'});

            } else {

                console.log("This Value");

                console.log(this.value);

                TweenMax.set('.team-office' , {display:'none'});
                var selector = "." + this.value;
                TweenMax.set(selector, {display:'block'});

            }

    });

    $("#sections")

        .select2({

            minimumResultsForSearch: -1

        })
        .on('change', function () {

            console.log("value");

            console.log(this.value);

            if (this.value === "Meet our regional teams"){

                console.log("all");

                TweenMax.set('.team-card', {display:'block'});

            } else {

                console.log("This Value");

                console.log(this.value);

                TweenMax.set('.team-card', {display: 'none'});
                var selector = "." + this.value;
                TweenMax.set(selector, {display: 'block'});

            }

        });

}

Map.prototype.setRegion = function (id, selector, text){



    $( id ).mouseover(function() {

        $(selector).addClass("hover");

        // TweenMax.set(selector, {class:'+=selected'});

    }).mouseout(function() {

        $(selector).removeClass("hover");

        //TweenMax.set(selector, {class:'-=selected'});

    }).click(function() {

        $('.americas').removeClass("selected");
        $('.africa').removeClass("selected");
        $('.asia-pacific').removeClass("selected");
        $('.europe').removeClass("selected");
        $('.middle-east').removeClass("selected");
        $('.uk').removeClass("selected");

        TweenMax.set('.region-text', {autoAlpha:0});

        TweenMax.to(text, 0.5, {autoAlpha:1});

        $(selector).addClass("selected");

    });
};

